import Container from 'quill/blots/container';
import type { Parchment } from 'quill/core';
import QuillBlockquote from 'quill/formats/blockquote';

export class BlockquoteContainer extends Container {}

class Blockquote extends QuillBlockquote {
  static register(registry: Parchment.Registry) {
    registry.register(BlockquoteContainer);
  }
}

BlockquoteContainer.blotName = 'blockquote-container';
BlockquoteContainer.tagName = 'BLOCKQUOTE';
BlockquoteContainer.allowedChildren = [Blockquote];

Blockquote.requiredContainer = BlockquoteContainer;
Blockquote.tagName = 'DIV';
Blockquote.className = 'ql-blockquote-block';

export default Blockquote;
